import { gql } from "@apollo/client";
import { lensSourceListItemFragment } from "../fragments";

export const getLensSourceList = gql`
    query getLensSourceList(
        $limit: Int
        $cursor: String
        $lensSourceType: LenssourceModelLensSourceType
        $query: LenssourceGetLensSourceListRequestQuery
        $organizationId: String = null
    ) {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        getLensSourceList(
            input: {
                limit: $limit
                query: $query
                organizationId: $organizationId
                lensSourceType: $lensSourceType
                cursor: $cursor
            }
        ) {
            lensSourceList {
                ...LensSourceListItem
            }
            cursor
            hasMore
        }
    }
    ${lensSourceListItemFragment}
`;
